module.exports = __webpack_public_path__ + "img/wdrq5.5c776540.png";